import { render, staticRenderFns } from "./registerModel.vue?vue&type=template&id=011b859d&scoped=true"
import script from "./registerModel.vue?vue&type=script&lang=js"
export * from "./registerModel.vue?vue&type=script&lang=js"
import style0 from "./registerModel.vue?vue&type=style&index=0&id=011b859d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011b859d",
  null
  
)

export default component.exports